<template>
  <div class="container">
    <div class="container--section container--section-service">
      <h2>Send a service message</h2>
      <h5>Report any issues straight to us</h5>
        <form v-on:submit.prevent="submitForm">
          <fieldset>
            <div class="row">
              <div class="column">
                <label for="email">Your Email</label>
                <input type="text" id="email" v-model="form.email" placeholder="you@email.com">
              </div>
              <div class="column">
                <label for="phone">Your Phone (optional)</label>
                <masked-input
                  v-model="form.phone"
                  mask="\+6\1 (01) 1111 1111"
                  placeholder="phone number"
                  type="text"
                  v-if="this.$route.query.room == 49 || this.$route.query.room == 114 || this.$route.query.room == 131 || this.$route.query.room == 133 || this.$route.query.room == 178" />

                <!-- Australian telephone -->
                <masked-input
                  v-model="form.phone"
                  mask="\+\6\1 1111 111111"
                  placeholder="phone number"
                  type="text"
                  v-else-if="this.$route.params.orgId == 450828" />

                <!-- UK telephone -->
                <masked-input
                  v-model="form.phone"
                  mask="\+\44 1111 111111"
                  placeholder="phone number"
                  type="text"
                  v-else-if="isUkOrg(this.$route.params.orgId)" />
                <masked-input
                  v-model="form.phone"
                  mask="\+\1 (111) 111-1111"
                  placeholder="phone number"
                  type="text"
                  v-else />

              </div>
            </div>
            <label for="comment">Comment(s)</label>
            <textarea id="comment" v-model="form.comment" placeholder="Let us know about any issue you found with a machine or the facility"></textarea>

            <div id="recaptcha-container"></div>

            <input class="button-primary g-recaptcha" type="submit" value="Send" v-if="!isLoading">
            <input class="button-primary" type="submit" value="Sending" disabled v-else>

            <span class="success" v-if="hasSent">
              Successfully sent. Thank you for notifying us.
            </span>

          </fieldset>
        </form>
    </div>
  </div>
</template>

<script>
import MaskedInput from "vue-masked-input";
import { sendServiceEmail } from "../services/data";

export default {
  name: "Service",
  data() {
    return {
      form: {},
      isLoading: false,
      hasSent: false,
      ukOrgs: ['891908', '760256', '486822', '862928', '1090139', '652210', '912247', '767776', '499898'],
      siteKey: window.siteKey,
    };
  },
  components: {
    MaskedInput
  },
  methods: {

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    isUkOrg(orgId) {
      return this.ukOrgs.indexOf(orgId) > -1
    },

    async submitForm() {

      if (!this.isValidEmail(this.form.email)) {
        alert("Please include your email with your message.")
        return;
      }

      this.isLoading = true;

      grecaptcha.ready(() => {
        grecaptcha.execute(this.siteKey, {action: 'submit'}).then((recaptchaToken) => {
          this.form.recaptchaToken = recaptchaToken
          const roomId = this.$route.query.room;

          this.$ga.event({
            eventCategory: 'room ' + this.$route.query.room,
            eventAction: 'service-email-sending'
          });

          sendServiceEmail(roomId, this.form)
            .then(() => { // TODO: Handle any errors from the endpoint
              this.form = {};
              this.hasSent = true;
              console.log("sent");
              console.log('event:service-email-sent');
              this.$ga.event({
                eventCategory: 'room ' + this.$route.query.room,
                eventAction: 'service-email-sent'
              });
            })
            .catch(error => {
              console.log('event:service-email-failed');
              this.$ga.event({
                eventCategory: 'room ' + this.$route.query.room,
                eventAction: 'service-email-failed'
              });
              console.log(error);
              alert("Unable to send email. Please check your email address and try again.");
            })
            .finally(() => {
              this.isLoading = false;
            });
          })
        })
    }
  }
};
</script>

<style scoped>
h2 {
  margin-bottom: 0;
}

.container--section-service {
  margin: 2em 0;
}

input[type="text"],
textarea {
  background: white;
}

#comment {
  height: 150px;
}

.success {
  margin-left: 10px;
}

.container {
  color: white;
  background: #1d2531;
}
</style>



// WEBPACK FOOTER //
// src/components/Service.vue